<template>
  <p1 v-i18n="landingPage" :class="childClass">
    {{ text }}
  </p1>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    childClass: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: 'text-text-primary-light-grey',
    },
  },
  data: function () {
    return {
      landingPage: 'landingPage',
    }
  },
}
</script>
